import { Action } from '@ngrx/store';

export enum UserResourceSubscriptionActionTypes {
  FETCH_RESOURCE_SUBSCRIPTION = '[User Resource Subscription] Fetch Resource Subscription',
  FETCH_RESOURCE_SUBSCRIPTION_SUCCESS = '[User Resource Subscription] Fetch Resource Subscription Success',
  FETCH_RESOURCE_SUBSCRIPTION_FAILED = '[User Resource Subscription] Fetch Resource Subscription Failed',
  UPDATE_RESOURCE_SUBSCRIPTION = '[User Resource Subscription] Update Resource Subscription',
  UPDATE_RESOURCE_SUBSCRIPTION_SUCCESS = '[User Resource Subscription] Update Resource Subscription Success',
  UPDATE_RESOURCE_SUBSCRIPTION_FAILED = '[User Resource Subscription] Update Resource Subscription Failed',
}

export interface UserAndResourcePayload {
  userId: string;
  resourceId: string;
}

export class FetchResourceSubscriptionAction implements Action {
  readonly type =
    UserResourceSubscriptionActionTypes.FETCH_RESOURCE_SUBSCRIPTION;

  constructor(public payload: UserAndResourcePayload) {}
}

export interface ResourceSubscriptionPayload {
  isSubscribed: boolean;
  resourceId: string;
}

export class FetchResourceSubscriptionSuccessAction implements Action {
  readonly type =
    UserResourceSubscriptionActionTypes.FETCH_RESOURCE_SUBSCRIPTION_SUCCESS;

  constructor(public payload: ResourceSubscriptionPayload) {}
}

export interface ErrorAndResourcePayload {
  error: any;
  resourceId: string;
}

export class FetchResourceSubscriptionFailedAction implements Action {
  readonly type =
    UserResourceSubscriptionActionTypes.FETCH_RESOURCE_SUBSCRIPTION_FAILED;

  constructor(public payload: ErrorAndResourcePayload) {}
}

export class UpdateResourceSubscriptionAction implements Action {
  readonly type =
    UserResourceSubscriptionActionTypes.UPDATE_RESOURCE_SUBSCRIPTION;

  constructor(public payload: UserAndResourcePayload) {}
}

export class UpdateResourceSubscriptionSuccessAction implements Action {
  readonly type =
    UserResourceSubscriptionActionTypes.UPDATE_RESOURCE_SUBSCRIPTION_SUCCESS;

  constructor(public payload: ResourceSubscriptionPayload) {}
}

export class UpdateResourceSubscriptionFailedAction implements Action {
  readonly type =
    UserResourceSubscriptionActionTypes.UPDATE_RESOURCE_SUBSCRIPTION_FAILED;

  constructor(public payload: ErrorAndResourcePayload) {}
}

export type UserResourceSubscriptionActions =
  | FetchResourceSubscriptionAction
  | FetchResourceSubscriptionSuccessAction
  | FetchResourceSubscriptionFailedAction
  | UpdateResourceSubscriptionAction
  | UpdateResourceSubscriptionSuccessAction
  | UpdateResourceSubscriptionFailedAction;
